import React from 'react';
import moment from 'moment';
import { delimitNumber } from '@src/utils/number';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import { useTranslation } from 'react-i18next';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import useUserInfo from '@src/hooks/useTtsUser';
import { StyledPackageV3 } from './index.style';
import UsedCredits from './UsedCredits';
import NextResetCycle from './NextResetCycle';
import ProgressBar from './ProgressBar';
// import CreditUsageRule from './CreditsUsageRule';
import ExpDate from '../components/ExpDate';

const PackageV3 = ({
  wallet,
  // hasV2Package,
  isMonthlyPackage,
  isMobile,
  isAutoRenewalPackage,
  totalCapturedRolloverCredits,
}) => {
  const {
    usedCredits,
    usedCreditsPercent,
    creditsPerCycle,
    totalCredits,
    hasNextResetCycle,
    nextResetAt,
    packageExpiryDate,
    purchasedTopUpCredits,
  } = wallet;
  const { ttsUser } = useUserInfo();
  const hasExpired =
    packageExpiryDate && moment(packageExpiryDate).isBefore(moment());
  const { i18n } = useTranslation();
  const { t, language } = i18n;
  const { user = {} } = useSelector((state) => state.auth);
  const { getFeatureValue } = useFeatureFlags();

  const useLockCycle = getFeatureValue(FEATURE_KEYS.LOCK_CYCLE_CREDITS, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useLockTopUp = getFeatureValue(FEATURE_KEYS.LOCK_TOP_UP_CREDITS, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const renderNote = () => {
    if (purchasedTopUpCredits && !useLockTopUp)
      return (
        <Typography
          component="span"
          className="list-note"
          dangerouslySetInnerHTML={{
            __html: t('contentTooltipLockCycleHasCharacters', {
              characters: delimitNumber(purchasedTopUpCredits, language),
            }),
          }}
        />
      );

    return <div className="list-note">{t('contentTooltipLockCredits')}</div>;
  };

  const renderNoteLockCreditForMobile = () => {
    if (useLockCycle && ttsUser?.studio?.cycle?.isLocked)
      return (
        <div className="lock-cycle-notification">
          <LockRoundedIcon className="icon-lock-cycle" />
          {renderNote()}
        </div>
      );

    if (useLockTopUp && ttsUser?.studio?.topUp?.isLocked)
      return (
        <div className="lock-cycle-notification">
          <LockRoundedIcon className="icon-lock-cycle" />
          {renderNote()}
        </div>
      );

    return <></>;
  };

  return (
    <StyledPackageV3>
      {!hasExpired && (
        <>
          <UsedCredits
            usedCredits={usedCredits}
            totalCredits={totalCredits}
            creditsPerCycle={creditsPerCycle}
            purchasedTopUpCredits={purchasedTopUpCredits}
            isMobile={isMobile}
            useLockCycle={useLockCycle}
            useLockTopUp={useLockTopUp}
            isAutoRenewalPackage={isAutoRenewalPackage}
            hasNextResetCycle={hasNextResetCycle}
            totalCapturedRolloverCredits={totalCapturedRolloverCredits}
          />

          {isMobile && renderNoteLockCreditForMobile()}

          {hasNextResetCycle && !isMonthlyPackage && (
            <NextResetCycle
              creditsPerCycle={creditsPerCycle}
              nextResetAt={nextResetAt}
            />
          )}
          <ProgressBar value={usedCreditsPercent} />
        </>
      )}
      <ExpDate packageExpiryDate={packageExpiryDate} />
      {/* {hasV2Package && <CreditUsageRule />} */}
    </StyledPackageV3>
  );
};

export default PackageV3;
